import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import styled from 'styled-components';
import BookElement from 'app/api/bookElement';

import { Box, Text, Layer as GrommetLayer } from 'grommet';
import { Expand, Contract } from 'grommet-icons';
import ReactFrameComponent from 'react-frame-component';

import Button from 'app/components/Button';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const Container = styled.div`
  max-width: 600px;
  margin: 32px auto;
`;

const Frame = styled(ReactFrameComponent)`
  border: none;
  width: 100%;
`;

const Layer = styled(GrommetLayer)`
  width: 100%;
  overflow: hidden;
`;

const ButtonBar = styled.div`
  width: 100%;
  height: 24px;
  padding: 12px 12px 0;
  cursor: pointer;
  @media (max-width: 600px) {
    svg {
      width: 100%;
    }
  }
`;

const defaultIFrameContent = '<div></div>'

class IFrame extends React.Component {
  constructor(props) {
    super(props);
    this.height = 400;
    this.state = {
      height: 8,
      isFullscreen: false,
    };
  }

  onOpen = () => {
    this.props.AppState.toggleFullscreen();
    this.setState({ isFullscreen: true });
  };
  onClose = () => {
    this.props.AppState.toggleFullscreen();
    this.setState({ isFullscreen: false });
  };
  render() {
    const { AppState, path, content } = this.props;
    const { isFullscreen } = this.state;
    const initialContent =
      !content.source.startsWith('http') ?
      require('html-loader!../../../content' + content.source):
      defaultIFrameContent;
    const source = content.source.startsWith('http') ? content.source: undefined;
    return (
      <Container aria-label="iframe">
        <ScrollIntoViewIfNeeded
          options={scrollIntoViewOptions}
          active={_.isEqual(path, AppState.selectedSectionItem)}
        >
          <Box align="center">
            <Box elevation="small" width="100%">
              <Button
                direction="row"
                pad="small"
                align="center"
                justify="between"
                width="100%"
                height="40px"
                background="light-4"
                border="bottom"
                responsive
                onClick={this.onOpen}
              >
                Expand
                <Expand color="black" />
              </Button>
              <Frame
                id={content.source}
                height={this.state.height}
                onLoad={() => {
                  const intervalID = setInterval(() => {
                    const iframe = document.getElementById(content.source);
                    if (iframe) {
                      const { documentElement } = iframe.contentWindow.document;
                      if (documentElement.scrollHeight !== 8) {
                        this.setState({
                          height: _.min([
                            documentElement.scrollHeight,
                            this.height,
                          ]),
                        });
                        clearInterval(intervalID);
                      }
                    }
                  }, 100);
                }}
                src={source}
                initialContent={initialContent}
              />
              {/* <iframe title={content.source} src={process.env.PUBLIC_URL + content.source} style={{border: 0}}/> */}
              {isFullscreen && (
                <Layer
                  responsive
                  full
                  position="center"
                  onClickOutside={this.onClose}
                  onEsc={this.onClose}
                >
                  <ButtonBar onClick={this.onClose}>
                    <Contract />
                  </ButtonBar>
                  <Box pad="xsmall" align="center">
                    <Frame
                      id={content.source}
                      height={this.state.height}
                      onLoad={() => {
                        const intervalID = setInterval(() => {
                          const iframe = document.getElementById(
                            content.source
                          );
                          if (iframe) {
                            const {
                              documentElement,
                            } = iframe.contentWindow.document;
                            if (documentElement.scrollHeight !== 8) {
                              this.setState({
                                height: documentElement.scrollHeight,
                              });
                              clearInterval(intervalID);
                            }
                          }
                        }, 100);
                      }}
                      src={source}
                      initialContent={initialContent}
                    />
                  </Box>
                </Layer>
              )}
            </Box>
            <Text weight="bold" textAlign="center">
              {BookElement.extractTitleFromPath(path)} — {content.caption}
            </Text>
          </Box>
        </ScrollIntoViewIfNeeded>
      </Container>
    );
  }
}

IFrame.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * source, caption, postfix, and prefix
   */
  content: PropTypes.shape({
    source: PropTypes.string,
    caption: PropTypes.string,
    prefix: PropTypes.string,
    postfix: PropTypes.string,
  }),
};
IFrame.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(IFrame));
Component.displayName = 'IFrame';
export const IFrameComponent = IFrame;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/IFrame.js